import { render, staticRenderFns } from "./App.vue?vue&type=template&id=481ccc16&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=481ccc16&prod&lang=scss&"
import style1 from "./vuetify-custom.scss?vue&type=style&index=1&prod&lang=scss&"
import style2 from "./theme-global.scss?vue&type=style&index=2&prod&lang=scss&"
import style3 from "./assets/style.css?vue&type=style&index=3&prod&lang=css&"
import style4 from "./App.vue?vue&type=style&index=4&id=481ccc16&prod&lang=scss&scoped=true&"
import style5 from "./App.vue?vue&type=style&index=5&id=481ccc16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ccc16",
  null
  
)

export default component.exports